import { Component, ElementRef, EventEmitter, Input, OnInit, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { NgForm } from '@angular/forms';
import { User, isInvalidEmail } from 'app/models/user';
import { DashNotificationsService } from 'app/services/dash-notifications.service';
import { ListingInquiry, ListingInquryService } from 'app/services/listing-inqury.service';
import { fromEvent, merge } from 'rxjs';


@Component({
  selector: 'listing-contact',
  templateUrl: './listing-contact.component.html',
  styleUrls: ['./listing-contact.component.scss']
})
export class ListingContactComponent implements OnInit {

  @Output() onClickThrough: EventEmitter<null> = new EventEmitter();
  @Output() afterSubmit: EventEmitter<null> = new EventEmitter();
  @Input() primaryAgent: User;
  @Input() timelineId: number;

  displayEmailInvalid = false // only affects dom if form submission was attempted (see template)

  @ViewChild('listingInquiryForm') listingInquiryForm: NgForm;
  @ViewChildren('clickThroughEl', { read: ElementRef }) clickThroughRefs: QueryList<ElementRef<HTMLElement>>;

  listingInquiry: ListingInquiry = {
    question: '',
    timelineId: null,
    emailAddress: '',
  };

  constructor(
    private notifications: DashNotificationsService,
    private listingInquiryService: ListingInquryService
  ) { }

  ngOnInit(): void {
    this.listingInquiry.timelineId = this.timelineId;
  }

  ngAfterViewInit() {
    merge(
      ...this.clickThroughRefs.map(el => fromEvent(el.nativeElement, 'click'))
    ).subscribe(() => {
      this.onClickThrough.emit();
    })
  }

  validateEmailOnChange($event: string): void {
    this.displayEmailInvalid = isInvalidEmail($event);
  }

  onSubmit(): void {
    if (isInvalidEmail(this.listingInquiry.emailAddress)) {
      this.displayEmailInvalid = true;
      this.notifications.error('Please provide a valid email address.', { header: 'Almost There!' })
      return;
    }

    this.listingInquiryService.submit(this.listingInquiry)
      .subscribe(
        () => {
            this.listingInquiryForm.resetForm();
            this.afterSubmit.emit();
          },
        () => { }
      );
  }
}
